import { useEffect } from 'react';
import { useApproval } from '../hooks/useApproval';
import { jsx as _jsx } from "react/jsx-runtime";
export const withApproval = WrappedComponent => {
  const WithApproval = props => {
    const {
      approvableObjectId
    } = props;
    const approval = useApproval(props);
    const enabled = approval.config.enabled;
    useEffect(() => {
      if (enabled === true && approvableObjectId) {
        approval.api.fetchLatest();
      }
    }, [enabled, approvableObjectId]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
      approval.api.fetchConfig();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      approval: approval
    }));
  };
  return WithApproval;
};